import Slideshow from '../slideshow/slideshow';
import * as $ from 'jquery';

export default class Home {

    private mainSlideshowAjaxUrl:string;
    private mainSlideshowElement:any;
    private mainSlideshow:Slideshow;
    private inputShowEmissionSelector:any;
    private mainSlideshowDateElement:any;
    private emissionElement:any;
    private emissionLoader:any;

    private bestSellersSlideshowElement:any;
    private bestSellersSlideshow:Slideshow;
    private bestSellersSlideshowAjaxUrl:string;

    private eventsSlideshowElement:any;
    private eventsSlideshow:Slideshow;
    private eventsSlideshowAjaxUrl:string;

    constructor() {
        this.initMainSlideshow();
        this.initBestSellersSlideshow();
        this.initEventsSlideshow();
        this.initTshevents();
        this.checkPriceSize();

    }

    /**
     * check the price size of the products slideshow.
     */
    protected checkPriceSize() {
        jQuery(function() {
            var priceBox = jQuery('.slideshow-container .price-box');
            if(priceBox) {
                priceBox.each(function( index ) {
                    var price = jQuery( '.price', this );
                    var priceLength = price.text().trim().length;

                    if(priceLength > 9) {
                        jQuery(this).css('min-height', '43px');
                        var picto = jQuery('.picto', this);
                        var oldPrice = jQuery('.old-price', this);
                        var priceNewSize = '26px';
                        var pictoNewSize = '20px';
                        var oldPriceNewSize = '12px';
                        if(priceLength > 10) {
                            priceNewSize = '21px';
                            pictoNewSize = '18px';
                            if(oldPrice && oldPrice.text().trim().length > 10) {
                                oldPriceNewSize = '10px';
                            }
                        }
                        price.css('font-size', priceNewSize);
                        if(picto) {
                            picto.css('font-size', pictoNewSize);
                            // picto.css('margin-bottom', '9px');
                        }
                        if(oldPrice && oldPrice.text().trim().length > 9) {
                            oldPrice.css('font-size', oldPriceNewSize);
                        }
                    }
                });
            }
        });
    }

    initTshevents() {
        const img = $('#tshevent img');

        img.each((index, imgElement) => {
            $(imgElement).attr('src', $(imgElement).attr('data-src'));
        });
    }

    /**
     *
     * @param url
     * @param slideshow
     * @param beforeAdd
     * @param afterAdd
     */
    protected loadSlideshowData(url, slideshow:Slideshow = this.mainSlideshow, beforeAdd:any = null, afterAdd:any = null) {
        $.ajax(url).done((data) => {
            if (typeof data.productsHtml !== 'undefined') {
                if (beforeAdd) beforeAdd(data);

                data.productsHtml.forEach(html => {
                    slideshow.addElement(html);
                });

                if (afterAdd) afterAdd(data);
            }
        });
    }

    /**
     * Initialize Slideshow
     */
    initMainSlideshow() {
        this.mainSlideshowElement = $('#emission-slideshow');
        this.mainSlideshowAjaxUrl = $('#slideshow').data('ajax-url');
        this.inputShowEmissionSelector = $('#emissions-shower');
        this.mainSlideshowDateElement = $('#slideshow-date');
        this.emissionElement = $('#emissions');
        this.emissionLoader = this.emissionElement.find('.loader-overlay');
        this.mainSlideshow = new Slideshow(this.mainSlideshowElement, 4);

        this.loadSlideshowData(this.mainSlideshowAjaxUrl);

        setTimeout(() => this.emissionElement.addClass('initialized'), 600);

        this.emissionElement.find('.emission').click((event) => {
            const emissionUrl = $(event.currentTarget).data('emission');

            this.emissionLoader.addClass('active');

            this.loadSlideshowData(
                emissionUrl,
                this.mainSlideshow,
                () => this.mainSlideshow.emptySlideshow(),
                    data => {
                    this.mainSlideshowDateElement.html(data.emissionDate);
                    this.emissionLoader.removeClass('active');
                    this.inputShowEmissionSelector.prop('checked', false);
                }
            );
        });
    }

    /**
     * Initialiaze Best sellers slideshow
     */
    initBestSellersSlideshow() {

        this.bestSellersSlideshowElement = $('#best-sellers-slideshow');
        this.bestSellersSlideshowAjaxUrl = this.bestSellersSlideshowElement.data('ajax-url');
        this.bestSellersSlideshow = new Slideshow(this.bestSellersSlideshowElement, 4);

        this.loadSlideshowData(this.bestSellersSlideshowAjaxUrl, this.bestSellersSlideshow, () => {
            this.bestSellersSlideshow.emptySlideshow();
        });
    }

    /**
     * Initialiaze Events slideshow
     */
    initEventsSlideshow() {
        this.eventsSlideshowElement = $('#events-slideshow');
        this.eventsSlideshowAjaxUrl = this.eventsSlideshowElement.data('ajax-url');
        this.eventsSlideshow = new Slideshow(this.eventsSlideshowElement, 3);

        this.loadSlideshowData(this.eventsSlideshowAjaxUrl, this.eventsSlideshow, () => {
            this.eventsSlideshow.emptySlideshow();
        });
    }
}